"use strict";
var appn;
(function (appn) {
    var shortcuts;
    (function (shortcuts) {
        function init() {
            window.hotkeys.filter = () => {
                return true;
            };
            window.hotkeys('ctrl+s,ctrl+shift+d', function (event, handler) {
                switch (handler.key) {
                    case 'ctrl+s': {
                        event.preventDefault();
                        $('.navbar-default button[value="Save"]').click();
                        break;
                    }
                    case 'ctrl+shift+d': {
                        event.preventDefault();
                        appn.devWidget.widgetShortcut(event);
                        break;
                    }
                }
            });
        }
        shortcuts.init = init;
    })(shortcuts = appn.shortcuts || (appn.shortcuts = {}));
})(appn || (appn = {}));
